const INITIAL_STATE = {
  courseOptions: [],
  examOptions: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'COURSE_OPTIONS_UPDATED':
      return { ...state, courseOptions: action.options || [], courseOptionsLoaded: true }
    case 'EXAM_OPTIONS_UPDATED':
      return { ...state, examOptions: action.options || [], examOptionsLoaded: true }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/app.js